

const zeminTypeOptions = [
    {
        value: 2,
        text: "Saç Taban",
    },
    {
        value: 1,
        text: "Ahşap Taban",
    },
    {
        value: 0,
        text: "Farketmez",
    },

]

export default zeminTypeOptions